import { render } from "./CreateBooking.vue?vue&type=template&id=2fb86433"
import script from "./CreateBooking.vue?vue&type=script&lang=js"
export * from "./CreateBooking.vue?vue&type=script&lang=js"
script.render = render

export default script